// NOTE The component used colors.cloudGrey as hard-coded value for both default and native
var npsThemeWeb = {
  color: 'primary',
  background: 'background',
  closeButtonBackground: 'background',
  scoreOptionsBackground: 'background.secondary',
  textColors: {
    /**
     * Text color for labels: minScore and maxScore
     */
    scoreMinMax: 'text.secondary',
    /**
     * Text color for the descriptions: npsDescription and feedbackDescription
     */
    description: 'text',
    /**
     * Text color for the heading
     */
    heading: 'text'
  }
};

export { npsThemeWeb };
